/** Format des nouveaux pseudos : même règle que le déclencheur SQL. */
export const USERNAME_PATTERN = /^[a-z0-9_-]+$/;
export const DEFAULT_USERNAME_MIN = 3;
export const DEFAULT_USERNAME_MAX = 24;

/** Longueurs lues dans les réglages publics, défauts 3 et 24. */
export const getUsernameLengths = (auth?: {
  username_min_length?: number;
  username_max_length?: number;
}) => ({
  min: typeof auth?.username_min_length === "number" ? auth.username_min_length : DEFAULT_USERNAME_MIN,
  max: typeof auth?.username_max_length === "number" ? auth.username_max_length : DEFAULT_USERNAME_MAX,
});

export const usernameRuleMessage = (min: number, max: number) =>
  `Le pseudo accepte seulement des lettres minuscules, des chiffres, « _ » et « - », sans espaces (de ${min} à ${max} caractères).`;

export const isValidUsername = (value: string, min: number, max: number) =>
  USERNAME_PATTERN.test(value) && value.length >= min && value.length <= max;
